import React from "react";
import theme from "../../theme/theme";

// A small red "Conflict" chip shown when a meeting overlaps another meeting the
// user is committed to (a double-booking). Driven by the backend `hasConflict`
// flag (item 4). Renders nothing when there is no conflict.
const MeetingConflictBadge = ({ meeting }) => {
  if (!meeting?.hasConflict) return null;
  const color = theme.palette.error?.main || "#d32f2f";
  return (
    <span
      title="This meeting overlaps another meeting on your schedule"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        backgroundColor: `${color}1f`,
        color,
        border: `1px solid ${color}66`,
        borderRadius: 6,
        padding: "2px 8px",
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
      }}
    >
      ⚠ Conflict
    </span>
  );
};

export default MeetingConflictBadge;
